export const flagsCamilo = ["Atacarejo", "Varejo", "Atacado"];
